import React from 'react';
import ReactDOM from 'react-dom';
import Router from './router.js';
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import createLogger from 'redux-logger'
import rootReducer from './reducers';
import './index.css';
import apiMiddleware from './middleware/api';


const middleware = [ thunk ];
if (process.env.NODE_ENV !== 'production') {
	middleware.push(createLogger())
}
middleware.push(apiMiddleware());
let reduxStore = createStore(rootReducer, applyMiddleware(...middleware));

ReactDOM.render(
	<Provider store={reduxStore}>
		<Router />
	</Provider>,
	document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/